import { objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { toNumber } from '@costar-ui/utils';
import React, { useMemo } from 'react';
import { badgeStyles } from './badge.styles.esm.js';
import Slot from '../layout/slot/slot.esm.js';
import Text from '../text/text.esm.js';

var _excluded = ["badgeContent", "max", "variant", "size"];
function Badge(props) {
  var _props = _objectSpread2({}, props),
    badgeContent = _props.badgeContent,
    _props$max = _props.max,
    max = _props$max === void 0 ? 99 : _props$max,
    _props$variant = _props.variant,
    variant = _props$variant === void 0 ? 'primary' : _props$variant,
    _props$size = _props.size,
    size = _props$size === void 0 ? 'std' : _props$size,
    rest = _objectWithoutProperties(_props, _excluded);
  var _useMemo = useMemo(function () {
      return badgeStyles({
        variant: variant,
        size: size
      });
    }, [size, variant]),
    badge = _useMemo.badge,
    text = _useMemo.text;
  var numericalValue = toNumber(badgeContent);
  var displayValue = numericalValue > max ? "".concat(max, "+") : numericalValue;
  return /*#__PURE__*/React.createElement(Slot, _extends({
    className: badge(),
    alignItems: "center",
    justify: "center"
  }, rest), /*#__PURE__*/React.createElement(Text, {
    className: text()
  }, displayValue));
}

export { Badge as default };
//# sourceMappingURL=badge.esm.js.map
